
/* Global nav — the shared header component from src/figs-nav/ (source: the
   Navigation demo, experiments/09-navigation). Mounted once, in its own
   module and outside boot(), so a Replay rebuild never mounts it twice. */
import { mountFigsNav } from "/src/figs-nav/figs-nav.js";
mountFigsNav({
  promo: document.querySelector("[data-fnav-promo]"),
  masthead: document.querySelector("[data-fnav-masthead]"),
  theme: "dark",
  homeHref: "/experiments/08-d-homepage/",
});
